"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { NFTLite } from "@/components/user/settings/UserSettingsImgSelectMeme";
import { NextGenCollection } from "@/entities/INextgen";
import { Transaction } from "@/entities/ITransaction";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { Page } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { WALLET_ACTIVITY_FILTER_PARAM, WALLET_ACTIVITY_PAGE_PARAM } from "../UserPageActivityWrapper";
import UserPageStatsActivityWalletTableWrapper from "./table/UserPageStatsActivityWalletTableWrapper";
export enum UserPageStatsActivityWalletFilterType {
  ALL = "ALL",
  AIRDROPS = "AIRDROPS",
  MINTS = "MINTS",
  SALES = "SALES",
  PURCHASES = "PURCHASES",
  TRANSFERS = "TRANSFERS",
  BURNS = "BURNS",
}
const ENUM_AND_PATH: {
  type: UserPageStatsActivityWalletFilterType;
  path: string;
}[] = [{
  type: UserPageStatsActivityWalletFilterType.ALL,
  path: "all"
}, {
  type: UserPageStatsActivityWalletFilterType.AIRDROPS,
  path: "airdrops"
}, {
  type: UserPageStatsActivityWalletFilterType.MINTS,
  path: "mints"
}, {
  type: UserPageStatsActivityWalletFilterType.SALES,
  path: "sales"
}, {
  type: UserPageStatsActivityWalletFilterType.PURCHASES,
  path: "purchases"
}, {
  type: UserPageStatsActivityWalletFilterType.TRANSFERS,
  path: "transfers"
}, {
  type: UserPageStatsActivityWalletFilterType.BURNS,
  path: "burns"
}];
const enumToPath = (type: UserPageStatsActivityWalletFilterType): string => {
  const found = ENUM_AND_PATH.find(e => e.type === type);
  return found?.path ?? "";
};
const pathToEnum = (path: string): UserPageStatsActivityWalletFilterType => {
  const found = ENUM_AND_PATH.find(e => e.path === path);
  return found?.type ?? UserPageStatsActivityWalletFilterType.ALL;
};
export default function UserPageStatsActivityWallet(t0) {
  const $ = _c(75);
  const {
    profile,
    activeAddress
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [UserPageStatsActivityWalletFilterType.ALL]: "",
      [UserPageStatsActivityWalletFilterType.AIRDROPS]: "airdrops",
      [UserPageStatsActivityWalletFilterType.MINTS]: "mints",
      [UserPageStatsActivityWalletFilterType.SALES]: "sales",
      [UserPageStatsActivityWalletFilterType.PURCHASES]: "purchases",
      [UserPageStatsActivityWalletFilterType.TRANSFERS]: "transfers",
      [UserPageStatsActivityWalletFilterType.BURNS]: "burns"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const FILTER_TO_PARAM = t1;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t2;
  if ($[1] !== searchParams) {
    t2 = searchParams?.get(WALLET_ACTIVITY_FILTER_PARAM);
    $[1] = searchParams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const activity = t2;
  let t3;
  if ($[3] !== searchParams) {
    t3 = searchParams?.get(WALLET_ACTIVITY_PAGE_PARAM);
    $[3] = searchParams;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const page = t3;
  const [activeFilter, setActiveFilter] = useState(UserPageStatsActivityWalletFilterType.ALL);
  const [pageFilter, setPageFilter] = useState(page && !isNaN(+page) ? +page : 1);
  let t4;
  let t5;
  if ($[5] !== activity) {
    t4 = () => {
      setActiveFilter(pathToEnum(activity ?? ""));
    };
    t5 = [activity];
    $[5] = activity;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[8] !== page) {
    t6 = () => {
      setPageFilter(page && !isNaN(+page) ? +page : 1);
    };
    t7 = [page];
    $[8] = page;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  if ($[11] !== searchParams) {
    t8 = config => {
      const params = new URLSearchParams(searchParams?.toString() ?? "");
      for (const {
        name,
        value
      } of config) {
        params.set(name, value);
      }
      return params.toString();
    };
    $[11] = searchParams;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const createQueryString = t8;
  let t9;
  if ($[13] !== activeFilter || $[14] !== createQueryString || $[15] !== pathname || $[16] !== router) {
    t9 = filter => {
      const targetFilter = filter === activeFilter ? UserPageStatsActivityWalletFilterType.ALL : filter;
      router.replace(`${pathname}?${createQueryString([{
        name: WALLET_ACTIVITY_FILTER_PARAM,
        value: enumToPath(targetFilter)
      }, {
        name: WALLET_ACTIVITY_PAGE_PARAM,
        value: "1"
      }])}`);
    };
    $[13] = activeFilter;
    $[14] = createQueryString;
    $[15] = pathname;
    $[16] = router;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const onActiveFilter = t9;
  let t10;
  if ($[18] !== createQueryString || $[19] !== pathname || $[20] !== router) {
    t10 = page_0 => {
      router.replace(`${pathname}?${createQueryString([{
        name: WALLET_ACTIVITY_PAGE_PARAM,
        value: `${page_0}`
      }])}`, {
        scroll: false
      });
    };
    $[18] = createQueryString;
    $[19] = pathname;
    $[20] = router;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const onPageFilter = t10;
  const [totalPages, setTotalPages] = useState(1);
  let t11;
  if ($[22] !== activeAddress || $[23] !== profile) {
    t11 = () => [activeAddress?.toLowerCase() ?? profile.wallets?.map(_temp)].join(",");
    $[22] = activeAddress;
    $[23] = profile;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const getWalletsParam = t11;
  const [walletsParam, setWalletsParam] = useState(getWalletsParam());
  let t12;
  if ($[25] !== getWalletsParam) {
    t12 = () => {
      setWalletsParam(getWalletsParam());
    };
    $[25] = getWalletsParam;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== activeAddress || $[28] !== profile) {
    t13 = [activeAddress, profile];
    $[27] = activeAddress;
    $[28] = profile;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  useEffect(t12, t13);
  const t14 = `${pageFilter}`;
  let t15;
  if ($[30] !== activeFilter || $[31] !== t14 || $[32] !== walletsParam) {
    t15 = [QueryKey.PROFILE_TRANSACTIONS, {
      page_size: "10",
      page: t14,
      wallet: walletsParam,
      filter: activeFilter
    }];
    $[30] = activeFilter;
    $[31] = t14;
    $[32] = walletsParam;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== activeFilter || $[35] !== pageFilter || $[36] !== walletsParam) {
    t16 = async () => {
      const params_0 = {
        wallet: walletsParam,
        page_size: "10",
        page: `${pageFilter}`
      };
      if (activeFilter) {
        params_0.filter = FILTER_TO_PARAM[activeFilter];
      }
      return await commonApiFetch({
        endpoint: "transactions",
        params: params_0
      });
    };
    $[34] = activeFilter;
    $[35] = pageFilter;
    $[36] = walletsParam;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = {
      queryKey: t15,
      queryFn: t16,
      placeholderData: keepPreviousData
    };
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const {
    isFetching,
    isLoading: isFirstLoading,
    data
  } = useQuery(t17);
  let t18;
  if ($[41] !== data || $[42] !== isFetching || $[43] !== onPageFilter || $[44] !== pageFilter) {
    t18 = () => {
      if (isFetching) {
        return;
      }
      if (!data?.count) {
        onPageFilter(1);
        setTotalPages(1);
        return;
      }
      const pagesCount = Math.ceil(data.count / 10);
      if (pagesCount < pageFilter) {
        onPageFilter(pagesCount);
        return;
      }
      setTotalPages(pagesCount);
    };
    $[41] = data;
    $[42] = isFetching;
    $[43] = onPageFilter;
    $[44] = pageFilter;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  const t19 = data?.count;
  const t20 = data?.page;
  let t21;
  if ($[46] !== isFetching || $[47] !== t19 || $[48] !== t20) {
    t21 = [t19, t20, isFetching];
    $[46] = isFetching;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  useEffect(t18, t21);
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      queryKey: [QueryKey.MEMES_LITE],
      queryFn: _temp2
    };
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  const {
    isFetching: isFirstLoadingMemes,
    data: memes
  } = useQuery(t22);
  let t23;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      queryKey: [QueryKey.MEMELAB_LITE],
      queryFn: _temp3
    };
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  const {
    isFetching: isFirstLoadingMemeLab,
    data: memeLab
  } = useQuery(t23);
  let t24;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      queryKey: [QueryKey.NEXTGEN_COLLECTIONS],
      queryFn: _temp4
    };
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  const {
    data: nextgenCollections
  } = useQuery(t24);
  let t25;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="tw-flex"><h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Wallet Activity</h3></div>;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== data?.data) {
    t26 = data?.data ?? [];
    $[54] = data?.data;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== memes) {
    t27 = memes ?? [];
    $[56] = memes;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== memeLab) {
    t28 = memeLab ?? [];
    $[58] = memeLab;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== nextgenCollections) {
    t29 = nextgenCollections ?? [];
    $[60] = nextgenCollections;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  const t30 = isFirstLoading || isFirstLoadingMemes || isFirstLoadingMemeLab;
  let t31;
  if ($[62] !== activeFilter || $[63] !== isFetching || $[64] !== onActiveFilter || $[65] !== onPageFilter || $[66] !== pageFilter || $[67] !== profile || $[68] !== t26 || $[69] !== t27 || $[70] !== t28 || $[71] !== t29 || $[72] !== t30 || $[73] !== totalPages) {
    t31 = <div className="tw-mt-4 md:tw-mt-5">{t25}<UserPageStatsActivityWalletTableWrapper filter={activeFilter} profile={profile} transactions={t26} memes={t27} memeLab={t28} nextgenCollections={t29} totalPages={totalPages} page={pageFilter} isFirstLoading={t30} loading={isFetching} setPage={onPageFilter} onActiveFilter={onActiveFilter} /></div>;
    $[62] = activeFilter;
    $[63] = isFetching;
    $[64] = onActiveFilter;
    $[65] = onPageFilter;
    $[66] = pageFilter;
    $[67] = profile;
    $[68] = t26;
    $[69] = t27;
    $[70] = t28;
    $[71] = t29;
    $[72] = t30;
    $[73] = totalPages;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  return t31;
}
async function _temp4() {
  const nextgenCollectionsResponse = await commonApiFetch({
    endpoint: "nextgen/collections"
  });
  return nextgenCollectionsResponse.data;
}
async function _temp3() {
  const memeLabResponse = await commonApiFetch({
    endpoint: "memelab_lite"
  });
  return memeLabResponse.data;
}
async function _temp2() {
  const memesResponse = await commonApiFetch({
    endpoint: "memes_lite"
  });
  return memesResponse.data;
}
function _temp(w) {
  return w.wallet.toLowerCase();
}